export default "__VITE_ASSET__dfb05ba7__"